import { IGlobalBanner } from '../modules/shared/components/global-banner/global-banner.interface';
import { BannerCanvasTypesEnum } from '../modules/features-data/features-data.data';

export enum ActionsEnum {
  INIT_APP = 'INIT_APP',
  SET_GLOBAL_BANNER = 'SET_GLOBAL_BANNER',
  HIDE_GLOBAL_BANNER = 'HIDE_GLOBAL_BANNER',
  OPEN_GROWTH_DIALOG = 'OPEN_GROWTH_DIALOG',
}

// action payloads
export interface IOpenGrowthDialog {
  bannerCanvasType: BannerCanvasTypesEnum;
  featureName: string;
}

// action defintions
export interface InitApp {
  type: ActionsEnum.INIT_APP;
}

export interface SetGlobalBanner {
  type: ActionsEnum.SET_GLOBAL_BANNER;
  payload: IGlobalBanner;
}

export interface HideGlobalBanner {
  type: ActionsEnum.HIDE_GLOBAL_BANNER;
  payload: string; // banner id
}

export interface OpenGrowthDialog {
  type: ActionsEnum.OPEN_GROWTH_DIALOG;
  payload: IOpenGrowthDialog;
}

// action creators
export const initApp = (): InitApp => ({
  type: ActionsEnum.INIT_APP,
});

export const setGlobalBanner = (
  globalBanner: IGlobalBanner
): SetGlobalBanner => ({
  type: ActionsEnum.SET_GLOBAL_BANNER,
  payload: globalBanner,
});

export const hideGlobalBanner = (bannerId?: string): HideGlobalBanner => ({
  type: ActionsEnum.HIDE_GLOBAL_BANNER,
  payload: bannerId,
});

export const openGrowthDialog = (
  bannerCanvasType: BannerCanvasTypesEnum,
  featureName: string
): OpenGrowthDialog => ({
  type: ActionsEnum.OPEN_GROWTH_DIALOG,
  payload: {
    bannerCanvasType,
    featureName,
  },
});
